import axios from 'axios'
import React, { useEffect, useState } from 'react'

const CreateOpt = ({ setUpdateData }) => {
    const [data, setData] = useState([])
    const [servicesType, setservicesType] = useState('')
    const [city, setCity] = useState('')
    const [OperatorName, setOperatorName] = useState('')
    const [OperatorCode, setOperatorCode] = useState('')
    const [max, setMax] = useState('')
    const [min, setMin] = useState('')
    const [image, setImage] = useState(null)
    const token = localStorage.getItem('token');
    console.log({ servicesType });
    useEffect(() => {
        const fetchData = async () => {
            const response = await axios.get(`https://bharatdarshan.app/api/operator/get-operator-services-type`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            if (response?.data?.data?.length !== 0) {
                setData(response?.data?.data)
            }

            console.log({ response });

        }
        fetchData()
    }, [])

    const handleAddOperatoe = async () => {
        let message = ''
        try {
            // if (servicesType === '' || city === '' || OperatorName === '' || OperatorCode === '' || image === null) {
            //     if (servicesType === '') message = 'servicesType is required'
            //     if (servicesType.name === 'Electricity')  if (city === '') message = 'city is required'
            //     if (OperatorName === '') message = 'OperatorName is required'
            //     if (OperatorCode === '') message = 'OperatorCode is required'
            //     if (servicesType.name === 'Electricity') if (image === null) message = 'image is required'
            //     return alert(message)
            // }
            const formData = new FormData()
            formData.append('servicesType', servicesType._id)
            formData.append('city', city)
            formData.append('OperatorName', OperatorName)
            formData.append('OperatorCode', OperatorCode)
            formData.append('minAmount', min)
            formData.append('maxAmount', max)

            formData.append('images', image)


            await axios.post(`https://bharatdarshan.app/api/operator/create-operator`, formData, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((res) => {
                console.log({ res: res });
            })
        } catch (error) {
            console.log({ error });
        }
    }



    return (
        <div className='container'>
            <div className="row">
                <div className="col align-self-end">
                    <button onClick={() => setUpdateData('Table')} >Go Back</button>
                </div>
            </div>
            <div className="row">
                <div className="col-lg-3">
                    <select className="form-select" onChange={(e) => setservicesType(data.find(item => item._id === e.target.value))} >
                        <option selected>Choose Operator</option>
                        {
                            data?.map((item, index) => {
                                return (
                                    <option value={item._id} key={index}>{item?.name}</option>
                                )
                            })
                        }

                    </select>
                </div>
                <div className="col-lg-3">
                    <div className="mb-3">

                        <input type="text" className="form-control" onChange={(e) => setOperatorName(e.target.value)} placeholder="Operator Name" />
                    </div>
                </div>
                <div className="col-lg-3">
                    <div className="mb-3">

                        <input type="text" className="form-control" onChange={(e) => setOperatorCode(e.target.value)} placeholder="Operator Code" />
                    </div>
                </div>



                {
                    servicesType.name === 'Electricity' &&
                    <>
                        <div className="col-lg-3">
                            <div className="mb-3">

                                <input type="txet" className="form-control" onChange={(e) => setCity(e.target.value)} placeholder="City" />
                            </div>
                        </div>

                    </>

                }
                <div className="col-lg-3">
                    <div className="mb-3">
                        <input type="file" className="form-control" onChange={(e) => setImage(e.target.files[0])} />
                    </div>
                </div>

                <div className="col-lg-3">
                    <div className="mb-3">

                        <input type="number" className="form-control" onChange={(e) => setMin(e.target.value)} placeholder="Min Amount" />
                    </div>
                </div>

                <div className="col-lg-3">
                    <div className="mb-3">

                        <input type="number" className="form-control" onChange={(e) => setMax(e.target.value)} placeholder="Max Amount" />
                    </div>
                </div>

                <div className="col-lg-12">
                    <button onClick={() => handleAddOperatoe()} >Add Operator</button>
                </div>
            </div>
        </div>
    )
}

export default CreateOpt
